define("shared/components/shared/post/secondary/saved-captions/wrapper", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _object, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--modalCard--secondary">
    {{#if this.isEditing}}
      <Shared::Post::Secondary::SavedCaptions::Editor
        @location={{@location}}
        @savedCaptionToEdit={{@savedCaptionToEdit}}
        @setCaptionToEdit={{@setCaptionToEdit}}
        @exitEditingCaption={{perform @exitEditingCaption}}
      />
    {{else}}
      <div class="o--modalHeader u--row u--row--noCollapse">
        <p class="o--modalHeader__title u--col__11">
          {{t "posts.template.title"}}
        </p>
        <div class="u--col__1">
          <a class="u--float--right" {{on "click" (fn this.createNewSavedCaption "")}}>
            <span>
              {{svg-jar "add" class="o--icon--md o--icon--hl"}}
              <EmberTooltip @delay={{330}} @side="left">
                {{t "posts.template.tooltip"}}
              </EmberTooltip>
            </span>
          </a>
        </div>
      </div>
  
      <Shared::Post::Secondary::SavedCaptions::List
        @setCaptionToEdit={{@setCaptionToEdit}}
        @createNewSavedCaption={{this.createNewSavedCaption}}
        @location={{@location}}
        @mediaItem={{@mediaItem}}
        @postElementId={{@postElementId}}
        @post={{@post}}
        @socialProfile={{@socialProfile}}
      />
  
      <div class="o--modalFooter">
        <Shared::Ui::Button
          @type="outline"
          @additional="block"
          @text={{t "shared_words.done"}}
          @onClick={{@toggle}}
        />
      </div>
    {{/if}}
  </div>
  
  */
  {
    "id": "sHMJV8nJ",
    "block": "[[[10,0],[14,0,\"o--modalCard--secondary\"],[12],[1,\"\\n\"],[41,[30,0,[\"isEditing\"]],[[[1,\"    \"],[8,[39,1],null,[[\"@location\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\",\"@exitEditingCaption\"],[[30,1],[30,2],[30,3],[28,[37,2],[[30,4]],null]]],null],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,0],[14,0,\"o--modalHeader u--row u--row--noCollapse\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"o--modalHeader__title u--col__11\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"posts.template.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"u--col__1\"],[12],[1,\"\\n        \"],[11,3],[24,0,\"u--float--right\"],[4,[38,4],[\"click\",[28,[37,5],[[30,0,[\"createNewSavedCaption\"]],\"\"],null]],null],[12],[1,\"\\n          \"],[10,1],[12],[1,\"\\n            \"],[1,[28,[35,6],[\"add\"],[[\"class\"],[\"o--icon--md o--icon--hl\"]]]],[1,\"\\n            \"],[8,[39,7],null,[[\"@delay\",\"@side\"],[330,\"left\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,3],[\"posts.template.tooltip\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,8],null,[[\"@setCaptionToEdit\",\"@createNewSavedCaption\",\"@location\",\"@mediaItem\",\"@postElementId\",\"@post\",\"@socialProfile\"],[[30,3],[30,0,[\"createNewSavedCaption\"]],[30,1],[30,5],[30,6],[30,7],[30,8]]],null],[1,\"\\n\\n    \"],[10,0],[14,0,\"o--modalFooter\"],[12],[1,\"\\n      \"],[8,[39,9],null,[[\"@type\",\"@additional\",\"@text\",\"@onClick\"],[\"outline\",\"block\",[28,[37,3],[\"shared_words.done\"],null],[30,9]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[13],[1,\"\\n\"]],[\"@location\",\"@savedCaptionToEdit\",\"@setCaptionToEdit\",\"@exitEditingCaption\",\"@mediaItem\",\"@postElementId\",\"@post\",\"@socialProfile\",\"@toggle\"],false,[\"if\",\"shared/post/secondary/saved-captions/editor\",\"perform\",\"t\",\"on\",\"fn\",\"svg-jar\",\"ember-tooltip\",\"shared/post/secondary/saved-captions/list\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/post/secondary/saved-captions/wrapper.hbs",
    "isStrictMode": false
  });

  let WrapperComponent = (_class = class WrapperComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "store", _descriptor2, this);
    }

    get isEditing() {
      return this.args.savedCaptionToEdit !== null && this.args.savedCaptionToEdit !== undefined;
    }

    createNewSavedCaption(newCaptionContent) {
      const {
        currentGroup,
        currentUserModel
      } = this.auth;
      const savedCaption = this.store.createRecord('savedCaption', {
        content: newCaptionContent,
        group: currentGroup,
        user: currentUserModel
      });
      this.args.setCaptionToEdit(savedCaption);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "createNewSavedCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "createNewSavedCaption"), _class.prototype)), _class);
  _exports.default = WrapperComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WrapperComponent);
});